import React from 'react';
import bem from 'utils/bem';
import Icon from 'components/Icon';
import Text from 'components/Text';
import { useTimer } from './useTimer';

import './index.sass';

const { block, el } = bem('timer');
const Timer = ({ expireTime, onExpire }) => {
    const time = useTimer({ expireTime, onExpire });
    return (
        <div className={block()}>
            <div className={el('left')}>
                <Icon name={'warning-circle'} />
            </div>
            <div className={el('right')}>
                <div className={el('label')}><Text>Оставшееся время для оплаты</Text></div>
                <div className={el('value')}><Text>{time}</Text></div>
            </div>
        </div>
    )
}

export default Timer;
